import { makeCustomerCardsRepository } from 'modules/customer/infra/repositories';

import { ChangeReparcelingCardUseCase } from './implementations/ChangeReparcelingCardUseCase';

let instance: ChangeReparcelingCardUseCase | null = null;

export default function makeChangeReparcelingCardUseCase() {
  if (!instance) {
    const repository = makeCustomerCardsRepository();

    instance = new ChangeReparcelingCardUseCase(repository);
  }

  return instance;
}
